import api from "../api/axios";

export const login = async (data) => {

  const response = await api.post(
    "/Login/login",
    data
  );

  return response.data;
};